import { ThemeEvents } from "@theme/events";
import { morph } from "@theme/morph";

class StockUrgency extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockUrgency);
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockUrgency);
  }

  /**
   * Updates the stock urgency block when the selected variant changes.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateStockUrgency = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    if (!event.detail.data.html) return;

    const productId = this.dataset.productId;
    let newStockUrgency = null;

    if (productId) {
      const allStockUrgency = event.detail.data.html.querySelectorAll("stock-urgency");
      for (const stockUrgency of allStockUrgency) {
        if (stockUrgency.dataset.productId === productId) {
          newStockUrgency = stockUrgency;
          break;
        }
      }
    }

    if (!newStockUrgency) {
      newStockUrgency = event.detail.data.html.querySelector("stock-urgency");
    }

    if (!newStockUrgency) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    morph(this, newStockUrgency, { childrenOnly: true });
    this.style.setProperty(
      "--stock-urgency-fill",
      newStockUrgency.style.getPropertyValue("--stock-urgency-fill")
    );
  };
}

if (!customElements.get("stock-urgency")) {
  customElements.define("stock-urgency", StockUrgency);
}
